import React from 'react';
import styled, { keyframes } from 'styled-components';

// Animation pour faire flotter les ballons vers le haut
const floatUp = keyframes`
  0% {
    transform: translateY(80vh);
    opacity: 1;
  }
  100% {
    transform: translateY(-100vh);
    opacity: 0.9;
  }
`;

// Animation pour faire osciller les ballons
const sway = keyframes`
  0% { margin-left: 0px; }
  25% { margin-left: 20px; }
  50% { margin-left: 0px; }
  75% { margin-left: -20px; }
  100% { margin-left: 0px; }
`;

// Animation pour faire apparaître et disparaître le message
const fadeInOut = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  10% {
    opacity: 1;
    transform: translateY(0);
  }
  85% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-20px);
  }
`;

const BalloonsContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
  display: ${props => props.show ? 'block' : 'none'};
`;

const Balloon = styled.div`
  position: absolute;
  width: 60px;
  height: 80px;
  border-radius: 50%;
  background-color: ${props => props.color};
  bottom: 20vh;
  left: ${props => props.left}%;
  animation: ${floatUp} ${props => props.duration}s linear forwards, ${sway} 2s ease-in-out infinite;
  animation-delay: ${props => props.delay}s;
  z-index: 9999;
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  
  &::before {
    content: '';
    position: absolute;
    width: 12px;
    height: 18px;
    background-color: ${props => props.color};
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    border-radius: 50%;
    filter: brightness(0.9);
  }
  
  &::after {
    content: '';
    position: absolute;
    width: 2px;
    height: 100px;
    background-color: #444;
    bottom: -100px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const CelebrationMessage = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.95);
  padding: 25px 50px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  font-size: 3rem;
  font-weight: bold;
  color: #e91e63;
  text-align: center;
  z-index: 10000;
  animation: ${fadeInOut} 8s ease-in-out forwards;
  font-family: 'Playfair Display', serif;
  display: ${props => props.show ? 'block' : 'none'};
`;

const BalloonsAnimation = ({ show, onComplete, message = "Bonne Fête Papa !" }) => {
  // Couleurs des ballons
  const colors = [
    '#FF6B6B', // Rouge
    '#4A90E2', // Bleu
    '#FFD700', // Jaune
    '#66BB6A', // Vert
    '#9C27B0', // Violet
    '#FF9800', // Orange
    '#E91E63'  // Rose
  ];
  
  // Créer un tableau de 30 ballons avec des positions et délais aléatoires
  const balloons = Array.from({ length: 30 }).map((_, index) => ({
    id: index,
    left: Math.random() * 90 + 5, // Position horizontale entre 5% et 95%
    delay: Math.random() * 1.5,   // Délai réduit entre 0 et 1.5 secondes
    duration: Math.random() * 2 + 7, // Durée entre 7 et 9 secondes
    color: colors[Math.floor(Math.random() * colors.length)]
  }));
  
  // Terminer l'animation après 9 secondes
  if (show) {
    setTimeout(() => {
      if (onComplete) {
        onComplete();
      }
    }, 9000);
  }
  
  return (
    <>
      <BalloonsContainer show={show}>
        {balloons.map(balloon => (
          <Balloon
            key={balloon.id}
            left={balloon.left}
            delay={balloon.delay}
            duration={balloon.duration}
            color={balloon.color}
          />
        ))}
      </BalloonsContainer>
      <CelebrationMessage show={show}>{message}</CelebrationMessage>
    </>
  );
};

export default BalloonsAnimation;